export default __webpack_public_path__ + "static/media/ENFP-3.92d16c29.png";